import { render, staticRenderFns } from "./RecordsIpv6.vue?vue&type=template&id=39cfb11e&scoped=true&"
import script from "./RecordsIpv6.vue?vue&type=script&lang=js&"
export * from "./RecordsIpv6.vue?vue&type=script&lang=js&"
import style0 from "./RecordsIpv6.vue?vue&type=style&index=0&id=39cfb11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cfb11e",
  null
  
)

export default component.exports